import { CdkMenuModule } from '@angular/cdk/menu';
import { Component, inject, OnInit } from '@angular/core';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatTooltip } from '@angular/material/tooltip';
import { Credenciais } from 'src/app/models/credenciais.model';
import { ApiCotacoesService } from 'src/app/services/api-cotacoes.service';
import { ApiApiceService } from 'src/app/services/api/api-apice.service';
import { ControllerStatusService } from 'src/app/services/controller-status.service';
import { UtilsService } from 'src/app/services/utils.service';
import { MAPA_SEGURADORAS } from 'src/app/constants/mapa-seguradoras.constant';
import { IntegracaoConstants } from 'src/app/constants/integracao';

@Component({
  selector: 'app-menu-seguradoras',
  standalone: true,
  imports: [CdkMenuModule, MatTooltip, MatProgressSpinner],
  templateUrl: './menu-seguradoras.component.html',
  styleUrls: ['./menu-seguradoras.component.scss'],
})
export class MenuSeguradorasComponent implements OnInit {
  private apiCotacao = inject(ApiCotacoesService);
  private api = inject(ApiApiceService);
  private utilsService = inject(UtilsService);
  private controllerStatusService = inject(ControllerStatusService);

  private seguradoras = IntegracaoConstants.seguradoras;

  protected carregando = false;

  protected confsSeguradoras = [];
  protected confsSeguradorasInvalidas = [];

  private readonly seguradorasRemovidas = [
    this.seguradoras.POTTENCIAL.id,
    this.seguradoras.SOMPO.id,
  ];

  ngOnInit(): void {
    this.confsSeguradoras = this.controllerStatusService.confsSeguradoras;
    this.confsSeguradorasInvalidas =
      this.controllerStatusService.confsSeguradorasInv;

    this.sortSeguradoras(this.confsSeguradoras);
    this.sortSeguradoras(this.confsSeguradorasInvalidas);

    this.removeSeguradoras();

    this.atribuiCaminhoIcone();
  }

  private sortSeguradoras = (seguradoras: any[]): void => {
    seguradoras.sort((a, b) =>
      a.dados.nomeSeguradora.localeCompare(b.dados.nomeSeguradora)
    );
  };

  private removeSeguradoras() {
    this.confsSeguradoras = this.confsSeguradoras.filter(
      (x) => !this.seguradorasRemovidas.includes(x?.dados?.seguradora)
    );

    this.confsSeguradorasInvalidas = this.confsSeguradorasInvalidas.filter(
      (x) => !this.seguradorasRemovidas.includes(x?.dados?.seguradora)
    );
  }

  private atribuiCaminhoIcone() {
    const processarSeguradoras = (lista: any[]) => {
      lista.forEach((objeto) => {
        const nomePadronizado = objeto.dados.nomeSeguradora
          .toLowerCase()
          .replace(/\s/g, '')
          .replace(/(^|_)(\w)/g, (_, __, c) => c.toUpperCase());

        const nomeIcone = MAPA_SEGURADORAS[nomePadronizado] || nomePadronizado;

        objeto.imgIcone = `https://img.agger.com.br/assets/seguradoras/${nomeIcone}.png`;
      });
    };

    processarSeguradoras(this.confsSeguradoras);

    processarSeguradoras(this.confsSeguradorasInvalidas);
  }

  protected async acessaSeguradora(idIntegracao) {
    this.carregando = true;
    try {
      let credenciais: Credenciais | any = await this.api.getCfgSeg(
        idIntegracao
      );
      await this.apiCotacao.logarSeguradora(credenciais);
    } catch (error) {
      this.utilsService.alertCustom({
        txt: 'Falha ao buscar seguradora, tente novamente!',
        alertType: 'ERROR',
        duration: 4000,
      });
    } finally {
      this.carregando = false;
    }
  }
}
